import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'duration',
    standalone: false,
})
export class DurationPipe implements PipeTransform {
    transform(durationInMinutes: number | undefined): string {
        if (durationInMinutes === 0) {
            return '0 Min';
        }
        if (!durationInMinutes || isNaN(durationInMinutes)) {
            return '';
        }

        const hours = Math.floor(durationInMinutes / 60);
        const minutes = durationInMinutes % 60;
        let result = '';

        if (hours > 0) {
            result += `${hours} Hr`;
            if (hours > 1) {
                result += 's';
            }
        }
        if (minutes > 0) {
            if (hours > 0) {
                result += ' ';
            }
            result += `${minutes} Min`;
            if (minutes > 1) {
                result += 's';
            }
        }
        return result.trim();
    }
}
